import { getFullName } from 'utils/fomatting';

/**
 * Shown for the residue of profiles that have neither a stored name nor a first
 * name — Kombo returns `first_name` as nullable for ATS-sourced profiles.
 */
export const UNKNOWN_CANDIDATE_PROFILE_NAME = 'Unknown Candidate';

type CandidateProfileNameParts = {
  name?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  firstNameFromCv?: string | null;
  lastNameFromCv?: string | null;
};

/**
 * No service writes the `name` scalar, so reading it alone leaves the heading
 * blank on virtually every profile. Prefer it when it is populated, otherwise
 * compose the name from the parts that are. CV-sourced profiles carry the name
 * on the `FromCv` parts only, so they are the last fallback before "unknown".
 */
export const getCandidateProfileDisplayName = (
  candidateProfile: CandidateProfileNameParts
): string =>
  candidateProfile.name?.trim() ||
  getFullName(candidateProfile.firstName, candidateProfile.lastName, '') ||
  getFullName(
    candidateProfile.firstNameFromCv,
    candidateProfile.lastNameFromCv,
    UNKNOWN_CANDIDATE_PROFILE_NAME
  );
